import { cn } from '@natu/utils/cn';

import {
  type BorderRadius,
  type SBProps,
  type Size,
  type Spacing,
  type StoryblokPalette,
  type BlokItem,
  DynamicRender,
  resolveStoryblokStyles,
} from '../../../../utils';
import { UniversalComponent } from '../../UniversalComponent';

export interface SBContainerProps {
  bgColor?: StoryblokPalette;
  body?: BlokItem[];
  containerSize?: Size;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
  pxMobile?: Spacing;
  pxTablet?: Spacing;
  pxDesktop?: Spacing;
  pyMobile?: Spacing;
  pyTablet?: Spacing;
  pyDesktop?: Spacing;
  rtlMobile?: BorderRadius;
  rtlTablet?: BorderRadius;
  rtlDesktop?: BorderRadius;
  rtrMobile?: BorderRadius;
  rtrTablet?: BorderRadius;
  rtrDesktop?: BorderRadius;
  rblMobile?: BorderRadius;
  rblTablet?: BorderRadius;
  rblDesktop?: BorderRadius;
  rbrMobile?: BorderRadius;
  rbrTablet?: BorderRadius;
  rbrDesktop?: BorderRadius;
  tag?: string;
}

export const SBContainer = ({ blok }: SBProps<SBContainerProps>) => {
  const {
    bgColor,
    body,
    containerSize,
    mbMobile,
    mbTablet,
    mbDesktop,
    mtMobile,
    mtTablet,
    mtDesktop,
    pxMobile,
    pxTablet,
    pxDesktop,
    pyMobile,
    pyTablet,
    pyDesktop,
    rtlMobile,
    rtlTablet,
    rtlDesktop,
    rtrMobile,
    rtrTablet,
    rtrDesktop,
    rblMobile,
    rblTablet,
    rblDesktop,
    rbrMobile,
    rbrTablet,
    rbrDesktop,
    tag,
  } = blok;

  const className = resolveStoryblokStyles({
    size: containerSize,
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
    pr: pxMobile,
    prTablet: pxTablet,
    prDesktop: pxDesktop,
    pl: pxMobile,
    plTablet: pxTablet,
    plDesktop: pxDesktop,
    pt: pyMobile,
    ptTablet: pyTablet,
    ptDesktop: pyDesktop,
    pb: pyMobile,
    pbTablet: pyTablet,
    pbDesktop: pyDesktop,
    rtlMobile,
    rtlTablet,
    rtlDesktop,
    rtrMobile,
    rtrTablet,
    rtrDesktop,
    rblMobile,
    rblTablet,
    rblDesktop,
    rbrMobile,
    rbrTablet,
    rbrDesktop,
    className: bgColor?.value ? 'bg-[var(--bg-sb-color)]' : undefined,
  });

  const hasRadius =
    rtlMobile ||
    rtlTablet ||
    rtlDesktop ||
    rtrMobile ||
    rtrTablet ||
    rtrDesktop ||
    rblMobile ||
    rblTablet ||
    rblDesktop ||
    rbrMobile ||
    rbrTablet ||
    rbrDesktop;

  const style = bgColor?.value ? { '--bg-sb-color': bgColor?.value } : undefined;

  return (
    <UniversalComponent
      blok={blok}
      className={cn(hasRadius && 'overflow-clip', className)}
      style={style}
      tag={tag}
    >
      <DynamicRender data={body} />
    </UniversalComponent>
  );
};
